import axios from 'axios'
// import { Notification, MessageBox, Message } from 'element-ui'
// import store from '../store/index.js'
// import { getToken } from '@/utils/auth'
import errorCode from './errorCode.js'
// import JSONBIG  from 'json-bigint'  //处理数字精度,ie下有兼容问题
import {
	Loading
} from 'element-ui';
// 协议头处理
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 收到服务器响应后,then前对数据进行处理
// axios.defaults.transformResponse = [data => {
//   return JSONBIG.parse(data)
// }]

// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: '/cxWebAppApi',
	// 超时时间
	timeout: 60000
})
// request拦截器
service.interceptors.request.use(config => {
	let obj = JSON.parse(sessionStorage.getItem('webopenId'))
	config.data = {
		appid: 'wx31ad03628d4b36e3',
		openid:obj==null?'':obj.hasOwnProperty('openId')?obj.openId:'',
		...config.data
	}
	// console.log(`请求URL：====>`, config.url);
	// console.log(`请求参数：====>`, config.data || '无参数');
	// 是否需要设置 token
	const isToken = (config.headers || {}).isToken === false;

	// if (getToken() && !isToken) {
	//   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	// }
	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
		// console.log(`服务器响应：`, res.data);
		// 未设置状态码则默认成功状态
		const code = res.data.code || 200;
		return res.data
		// 获取错误信息
		const msg = errorCode[code] || res.data.msg || errorCode['default']
		if (code === 401) {
			// MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
			//     confirmButtonText: '重新登录',
			//     cancelButtonText: '取消',
			//     type: 'warning'
			//   }
			// ).then(() => {
			//   store.dispatch('LogOut').then(() => {
			//     location.href = '/index';
			//   })
			// })
		} else if (code === 500) {
			// Message({
			//   message: msg,
			//   type: 'error'
			// })
			return Promise.reject(new Error(msg))
		} else if (code !== 200) {
			// Notification.error({
			//   title: msg
			// })
			return Promise.reject('error')
		} else {
			return res.data
		}
	},
	error => {
		console.log(error)
		let {
			message
		} = error;
		if (message == "Network Error") {
			message = "接口连接发生异常";
		} else if (message.includes("timeout")) {
			message = "系统接口请求超时";
		} else if (message.includes("Request failed with status code")) {
			let options = {
				lock: true,
				text: '网站加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(194, 194, 194, 0.7)'
			}
			Loading.service(options);
			message = "系统接口" + message.substr(message.length - 3) + "异常";
		}
		return Promise.reject(error)
	}
)

export default service
